module.exports = __webpack_public_path__ + "static/media/bg-4.505f510f.png";